import React, { useContext, useEffect } from "react";
import ApplicationContext from "../../context/ApplicationContext";
import {
  Button,
  Checkbox,
  Container,
  Grid,
  GridColumn,
  Header,
  Icon,
  Menu,
  MenuHeader,
  MenuItem,
  MenuMenu,
  Segment,
  Sidebar,
  SidebarPushable,
  SidebarPusher,
} from "semantic-ui-react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { Dashboard } from "../pages/dashboard/Dashboard";
import { Login } from "../login";
import loadingImage from "../../images/loading.gif";
import { ProductTree } from "../pages/productTree/ProductTree";
import { AllTables } from "../pages/snooker/AllTables";
import { MobileMenu } from "../pages/snooker copy/MobileMenu";
import { AddProduct } from "../pages/products/AddProduct";
import { AllProducts } from "../pages/products/AllProducts";
import { AddInstructions, Instructions } from "../pages/Instructions";
import { MultiInstructions } from "../pages/Instructions/MultiInstructions";
import { CopyInstructions } from "../pages/Instructions/CopyInstructions";
import { SelectInstructions } from "../pages/Instructions/SelectInstructions";
import { AddOption, Options } from "../pages/Options";
import { AddExtra, Extras } from "../pages/extras";
import { AddVariation, Variations } from "../pages/variation";
import { Calls } from "../pages/Calls/Calls";
import { SnookerTableEditor } from "../pages/snooker/SnookerTableEditor";

export const Main: React.FC = (): JSX.Element => {
  const context = useContext(ApplicationContext);
  const [visible, setVisible] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const [loginView, setLoginView] = React.useState(true);
  const [loadingError, setLoadingError] = React.useState(false);
  const [width, setWidth] = React.useState(window.innerWidth);
  const [height, setHeight] = React.useState(window.innerHeight);

  let contentWidth = width;

  if (visible) {
    contentWidth = width - 150;
  }

  const updateDimensions = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const navigate = useNavigate();

  function showDashboard() {
    navigate("/Dashboard");
  }

  function showProductTreeView() {
    navigate("/TreeView");
  }

  function showSnookerView() {
    navigate("/AllTables");
  }

  function showMobileMenu() {
    navigate("/MobileMenu");
  }

  function showAddProducts() {
    navigate("/AddProduct");
  }

  function showProducts() {
    navigate("/Products");
  }

  function showAllExtras() {
    navigate("/Extras");
  }

  function showAddExtras() {
    navigate("/AddExtra");
  }

  function showVariations() {
    navigate("/Variations");
  }
  function showAddVariations() {
    navigate("/AddVariation");
  }

  function showAddInstructions() {
    navigate("/AddInstruction");
  }

  function showInstructions() {
    navigate("/Instructions");
  }

  function showOptions() {
    navigate("/Options");
  }

  function showAddOptions() {
    navigate("/AddOption");
  }

  function showMultiInstructions() {
    navigate("/MultiInstruction");
  }

  function showCopyInstructions() {
    navigate("/CopyInstructions");
  }

  const VerticalSidebar = () => (
    <Sidebar
      as={Menu}
      animation={"push"}
      direction={"left"}
      vertical
      visible={visible}
      width="thin"
    >
      <MenuItem as="a" onClick={() => showDashboard()}>
        <Icon name="dashboard" />
        <MenuHeader>Dashboard</MenuHeader>
      </MenuItem>
      <MenuItem>
        <Icon name="cocktail" />

        <MenuHeader>Menu Setting</MenuHeader>

        <MenuMenu>
          <MenuItem name="App" active={true} onClick={showProductTreeView} />
          <MenuItem name="Snooker" active={true} onClick={showSnookerView} />
          <MenuItem name="Mobile" active={true} onClick={showMobileMenu} />
        </MenuMenu>
      </MenuItem>
      <MenuItem>
        <Icon name="cocktail" />
        Helpers (temp)
        <MenuMenu>
          <MenuItem name="Products" active={true} onClick={showProducts} />
          <MenuItem
            name="Add product"
            active={true}
            onClick={showAddProducts}
          />
          <MenuItem name="-----" active={true} />

          <MenuItem name="Extras" active={true} onClick={showAllExtras} />
          <MenuItem name="Add Extra" active={true} onClick={showAddExtras} />

          <MenuItem name="-----" active={true} />

          <MenuItem name="Variations" active={true} onClick={showVariations} />
          <MenuItem
            name="Add Variations"
            active={true}
            onClick={showAddVariations}
          />
          <MenuItem name="-----" active={true} />

          <MenuItem
            name="Instruction"
            active={true}
            onClick={showInstructions}
          />
          <MenuItem
            name="Add Instruction"
            active={true}
            onClick={showAddVariations}
          />
          <MenuItem name="-----" active={true} />
          <MenuItem name="Options" active={true} onClick={showOptions} />
          <MenuItem name="Add Options" active={true} onClick={showAddOptions} />
        </MenuMenu>
      </MenuItem>
    </Sidebar>
  );

  const main = (): JSX.Element => (
    <div style={{ height: "100vh" }}>
      <SidebarPushable as={Segment} style={{ overflow: "hidden" }}>
        <VerticalSidebar />

        <SidebarPusher dimmed={false}>
          <div style={{ padding: 10 }}>
            <Header as="h3">
              <div onClick={() => setVisible(!visible)}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  fill="currentColor"
                  className="bi bi-list"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"
                  />
                </svg>
              </div>
            </Header>
            <hr />
          </div>
          {/* <Segment basic>
            <Header as="h3">
              <Menu inverted>
                <MenuItem name="Menu" />
              </Menu>
            </Header>
            test
          </Segment>*/}
          <div
            style={{
              paddingLeft: 10,
              overflowY: "scroll",
              height: "90vh",
              width: contentWidth,
            }}
          >
            <Container>{pages()}</Container>
          </div>
        </SidebarPusher>
      </SidebarPushable>
    </div>
  );

  const pages = (): JSX.Element => {
    return (
      <>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/Dashboard" element={<Dashboard />} />
          <Route path="/TreeView" element={<ProductTree />} />
          <Route path="/AllTables" element={<AllTables />} />
          <Route path="/MobileMenu" element={<MobileMenu />} />

          <Route path="/Products" element={<AllProducts />} />
          <Route path="/AddProduct" element={<AddProduct />} />
          <Route path="/AddProduct/:id" element={<AddProduct />} />
          <Route path="/AddProduct/:id/:type/:nav" element={<AddProduct />} />

          <Route path="/Instructions" element={<Instructions />} />
          <Route path="/AddInstruction" element={<AddInstructions />} />
          <Route path="/MultiInstruction" element={<MultiInstructions />} />
          <Route path="/AddInstruction/:id" element={<AddInstructions />} />
          <Route
            path="/AddInstruction/:id/:type/:nav"
            element={<AddInstructions />}
          />
          <Route path="/CopyInstructions" element={<CopyInstructions />} />
          <Route
            path="/CopyInstructions/:id/:nav"
            element={<CopyInstructions />}
          />
          <Route
            path="/SelectInstructions/:id/:nav"
            element={<SelectInstructions />}
          />

          <Route path="/Options" element={<Options />} />
          <Route path="/AddOption" element={<AddOption />} />
          <Route path="/AddOption/:id" element={<AddOption />} />

          <Route path="/Extras" element={<Extras />} />
          <Route path="/AddExtra" element={<AddExtra />} />
          <Route path="/AddExtra/:id" element={<AddExtra />} />

          <Route path="/Variations" element={<Variations />} />
          <Route path="/AddVariation" element={<AddVariation />} />
          <Route path="/AddVariation/:id" element={<AddVariation />} />

          <Route path="/Calls" element={<Calls />} />
          <Route path="/SnookerTables" element={<AllTables />} />

          <Route path="/SnookerTableEditor" element={<SnookerTableEditor />} />
          <Route
            path="/SnookerTableEditor/:id"
            element={<SnookerTableEditor />}
          />
        </Routes>
      </>
    );
  };

  const handleLoginSuccess = () => {
    setLoginView(false);
    //context.ViewPage.setView(ViewPage.home);
    //setViewProducts(true);
  };

  const handleRegister = () => {};
  const handleForgotPassword = () => {};

  const manager = (): JSX.Element => (
    <>
      {loginView ? (
        <Login
          successful={handleLoginSuccess}
          register={handleRegister}
          forgotPassword={handleForgotPassword}
        />
      ) : (
        <></>
      )}
      {loginView === false ? <>{main()}</> : <></>}
    </>
  );

  const loadingData = (): JSX.Element => {
    return (
      <>
        {loadingError ? (
          <div className="loading-center">
            {/* <img src={loadingImage} alt="Loading" /> */}
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            Error in communication with service
          </div>
        ) : (
          <div className="loading-center">
            <img src={loadingImage} alt="Loading" />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <div>{loading ? loadingData() : <>{manager()}</>}</div>
    </>
  );
};
